<template>
  <div class="bg-white">
    <CoverPage />
    <LatestNews/>
    <DownloadCard />
    
    <div class="bge3ceff-opa rounded-t-5555 mt-12 relative zindex1">
      <!-- <div class="absolute -top-56 right-8 md:block lg:block hidden">
        <img
          src="@/assets/images/bg-des/footer-bg.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div> -->
      <DownloadApp />
      <Footer />
    </div>
  </div>
</template>
<script>
import CoverPage from "./components/CoverPage.vue";
import DownloadCard from "./components/DownloadCard.vue";
import DownloadApp from "./components/DownloadApp.vue";
import LatestNews from "./components/LatestNews.vue";
import Footer from "./components/Footer.vue";
export default {
  components: {
    CoverPage,
    DownloadCard,
    DownloadApp,
    LatestNews,
    Footer,
  },

  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
